import { superAdminGet, superAdminPut } from './api';

export interface SuperAdminRegistrationSettings {
  id?: string;
  _id?: string;
  phoneOptionalEmailDomains: string[];
}

export function getSuperAdminRegistrationSettings(): Promise<SuperAdminRegistrationSettings> {
  return superAdminGet<SuperAdminRegistrationSettings>('/registration-settings');
}

export function updateSuperAdminRegistrationSettings(
  data: Pick<SuperAdminRegistrationSettings, 'phoneOptionalEmailDomains'>
): Promise<SuperAdminRegistrationSettings> {
  return superAdminPut<SuperAdminRegistrationSettings>('/registration-settings', data);
}
